export const IBAN_VALIDATOR_REGEX = /^(?!GB)[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;
export const ONLY_CHAR_VALIDATOR_REGEX = /^\D+$/;
